module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "exclusive"
  }, [(_vm.competition) ? [_c('div', {
    staticClass: "exclusive__img",
    style: (_vm.imgSrc)
  }, [(!_vm.$breakpoints.smDown) ? [_c('div', {
    staticClass: "exclusive__content"
  }, [_c('sk-layout', [(_vm.item.movie && _vm.item.use_movie_poster == '1') ? _c('sk-flex', {
    attrs: {
      "xs4": "",
      "sm4": "",
      "md2": ""
    }
  }, [_c('div', {
    staticClass: "movie-detail__poster ",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        (_vm.item.movie.youtube_id) ? _vm.dialogActive = true: _vm.dialogActive = false
      }
    }
  }, [_c('div', {
    staticClass: "movie-detail__poster-img"
  }, [_c('img', {
    staticClass: "img-responsive-height",
    attrs: {
      "src": _vm.item.movie.poster,
      "alt": ""
    }
  })]), _vm._v(" "), (!_vm.$breakpoints.xs) ? _c('sk-icon', {
    staticClass: "movie-detail__poster-play",
    attrs: {
      "play": ""
    }
  }) : _vm._e()], 1)]) : ((!_vm.item.use_movie_poster || _vm.item.use_movie_poster == '0') && _vm.item.poster_image) ? _c('sk-flex', {
    attrs: {
      "xs4": "",
      "sm4": "",
      "md2": ""
    }
  }, [_c('div', {
    staticClass: "movie-detail__poster movie-detail__poster-img--no-trailer"
  }, [_c('div', {
    staticClass: "movie-detail__poster-img"
  }, [_c('img', {
    staticClass: "img-responsive-height",
    attrs: {
      "src": _vm.item.poster_image.url,
      "alt": ""
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md6": ""
    }
  }, [(_vm.item.big_title) ? _c('h2', {
    staticClass: "h1"
  }, [_vm._v(_vm._s(_vm.item.big_title))]) : _vm._e(), _vm._v(" "), _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.title)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.strapline)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "exclusive__content-btns"
  }, [(_vm.item.vista_movie_id && !_vm.item.button_link && !_vm.item.button_text) ? _c('sk-button', {
    attrs: {
      "primary": _vm.item.vista_movie_id ? true : false,
      "tag": "a",
      "href": ("/details/" + (_vm.item.vista_movie_id))
    }
  }, [_vm._v("Book to Win\n                                ")]) : (!_vm.item.vista_movie_id && _vm.item.button_link && _vm.item.button_text) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": _vm.item.button_link
    }
  }, [_vm._v(_vm._s(_vm.item.button_text) + "\n                                ")]) : _c('div', {
    staticClass: "promo__content-btns"
  }, [(_vm.movie) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": _vm.comp.button_link
    }
  }, [_vm._v(_vm._s(_vm.comp.button_text) + "\n                                    ")]) : _vm._e()], 1), _vm._v(" "), _c('span', [_vm._v(" ")]), _vm._v(" "), [((_vm.item.button_2_link || _vm.item.button_2_text)) ? _c('sk-button', {
    attrs: {
      "tertiary": "",
      "tag": "a",
      "href": _vm.item.button_2_link
    }
  }, [_vm._v(_vm._s(_vm.item.button_2_text) + "\n                                    ")]) : _c('sk-button', {
    attrs: {
      "tertiary": "",
      "tag": "a",
      "href": ("/competition/" + (_vm.item.nid))
    }
  }, [_vm._v("View Competition\n                                        Details\n                                    ")])]], 2)])], 1)], 1)] : [(_vm.item.movie && _vm.item.use_movie_poster == '1') ? _c('div', {
    staticClass: "movie-detail__poster"
  }, [_c('div', {
    staticClass: "movie-detail__poster-img"
  }, [_c('img', {
    staticClass: "img-responsive-height",
    attrs: {
      "src": _vm.item.movie.poster,
      "alt": ""
    }
  })]), _vm._v(" "), (!_vm.$breakpoints.xs) ? _c('sk-icon', {
    staticClass: "movie-detail__poster-play",
    attrs: {
      "play": ""
    }
  }) : _vm._e()], 1) : ((!_vm.item.use_movie_poster || _vm.item.use_movie_poster == '0') && _vm.item.images && _vm.item.images.poster && _vm.item.images.poster.url) ? _c('div', {
    staticClass: "movie-detail__poster movie-detail__poster-img--no-trailer"
  }, [_c('div', {
    staticClass: "movie-detail__poster-img"
  }, [_c('img', {
    staticClass: "img-responsive-height",
    attrs: {
      "src": _vm.item.images.poster.url,
      "alt": ""
    }
  })])]) : _vm._e()]], 2), _vm._v(" "), (_vm.$breakpoints.smDown) ? _c('div', {
    staticClass: "exclusive__content"
  }, [_c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md6": ""
    }
  }, [(_vm.item.big_title) ? _c('h2', {
    staticClass: "h1"
  }, [_vm._v(_vm._s(_vm.item.big_title))]) : _vm._e(), _vm._v(" "), _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.title)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.strapline)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "exclusive__content-btns"
  }, [(_vm.item.vista_movie_id && !_vm.item.button_link && !_vm.item.button_text) ? _c('sk-button', {
    attrs: {
      "primary": _vm.item.vista_movie_id ? true : false,
      "tag": "a",
      "href": ("/details/" + (_vm.item.vista_movie_id))
    }
  }, [_vm._v("Book to Win\n                        ")]) : (!_vm.item.vista_movie_id && _vm.item.button_link && _vm.item.button_text) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": _vm.item.button_link
    }
  }, [_vm._v(_vm._s(_vm.item.button_text) + "\n                        ")]) : _c('div', {
    staticClass: "promo__content-btns"
  }, [(_vm.movie) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": _vm.comp.button_link
    }
  }, [_vm._v(_vm._s(_vm.comp.button_text) + "\n                            ")]) : _vm._e()], 1), _vm._v(" "), _c('span', [_vm._v(" ")]), _vm._v(" "), [((_vm.item.button_2_link || _vm.item.button_2_text)) ? _c('sk-button', {
    attrs: {
      "tertiary": "",
      "tag": "a",
      "href": _vm.item.button_2_link
    }
  }, [_vm._v(_vm._s(_vm.item.button_2_text) + "\n                            ")]) : _c('sk-button', {
    attrs: {
      "tertiary": "",
      "tag": "a",
      "href": ("/competition/" + (_vm.item.nid))
    }
  }, [_vm._v("View Competition\n                                Details\n                            ")])]], 2)])], 1)], 1) : _vm._e()] : [_c('div', {
    staticClass: "exclusive__img",
    style: (_vm.imgSrc)
  }, [(!_vm.$breakpoints.smDown) ? [_c('div', {
    staticClass: "exclusive__content"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.item.movie && _vm.item.use_movie_poster == '1') ? _c('sk-flex', {
    attrs: {
      "xs4": "",
      "sm4": "",
      "md2": ""
    }
  }, [_c('div', {
    staticClass: "movie-detail__poster"
  }, [_c('div', {
    staticClass: "movie-detail__poster-img"
  }, [_c('img', {
    staticClass: "img-responsive-height",
    attrs: {
      "src": _vm.item.movie.poster,
      "alt": ""
    }
  })]), _vm._v(" "), (!_vm.$breakpoints.xs) ? _c('sk-icon', {
    staticClass: "movie-detail__poster-play",
    attrs: {
      "play": ""
    }
  }) : _vm._e()], 1)]) : ((!_vm.item.use_movie_poster || _vm.item.use_movie_poster == '0') && _vm.item.images && _vm.item.images.poster && _vm.item.images.poster.url) ? _c('sk-flex', {
    attrs: {
      "xs4": "",
      "sm4": "",
      "md2": ""
    }
  }, [_c('div', {
    staticClass: "movie-detail__poster movie-detail__poster-img--no-trailer"
  }, [_c('div', {
    staticClass: "movie-detail__poster-img"
  }, [_c('img', {
    staticClass: "img-responsive-height",
    attrs: {
      "src": _vm.item.images.poster.url,
      "alt": ""
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs8": "",
      "sm8": "",
      "md6": "",
      "lg6": ""
    }
  }, [(_vm.item.big_title) ? _c('h2', {
    staticClass: "h1"
  }, [_vm._v(_vm._s(_vm.item.big_title))]) : _vm._e(), _vm._v(" "), _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.title)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.strapline)
    }
  }), _vm._v(" "), (!_vm.festival) ? _c('div', {
    staticClass: "exclusive__content-btns"
  }, [(!_vm.item.vista_movie_id && (_vm.item.button_link || _vm.item.button_text)) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": _vm.item.button_link,
      "block": ""
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.item.button_text) + "\n                                ")]) : ((_vm.item.vista_movie_id && (!_vm.item.button_link || !_vm.item.button_text)) || _vm.item.vista_movie_id && (_vm.item.button_link || _vm.item.button_text)) ? _c('sk-button', {
    attrs: {
      "block": _vm.$breakpoints.xs,
      "primary": _vm.item.vista_movie_id ? true : false,
      "tag": "a",
      "href": ("/details/" + (_vm.item.vista_movie_id))
    }
  }, [_vm._v(_vm._s(_vm.item.button_text || 'Book to Win') + "\n                                ")]) : _vm._e(), _vm._v(" "), ((_vm.item.button_2_link || _vm.item.button_2_text)) ? _c('sk-button', {
    attrs: {
      "tertiary": _vm.item.vista_movie_id != '',
      "primary": _vm.item.vista_movie_id == '',
      "tag": "a",
      "href": _vm.item.button_2_link
    }
  }, [_vm._v(_vm._s(_vm.item.button_2_text) + "\n                                ")]) : (_vm.promo) ? _c('sk-button', {
    attrs: {
      "tertiary": _vm.item.vista_movie_id != '',
      "primary": _vm.item.vista_movie_id == '',
      "tag": "a",
      "href": ("/promotion/" + (_vm.item.nid))
    }
  }, [_vm._v("View Promotion Details\n                                ")]) : (_vm.event) ? _c('sk-button', {
    attrs: {
      "tertiary": _vm.item.vista_movie_id != '',
      "primary": _vm.item.vista_movie_id == '',
      "tag": "a",
      "href": ("/event/" + (_vm.item.nid))
    }
  }, [_vm._v("View Event Details\n                                ")]) : _vm._e()], 1) : _c('div', {
    staticClass: "exclusive__content-btns"
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": ("/film-festival-details/" + (_vm.item.nid))
    }
  }, [_vm._v("See Features\n                                ")])], 1)])], 1)], 1)] : [(_vm.item.movie && _vm.item.use_movie_poster == '1') ? _c('div', {
    staticClass: "movie-detail__poster"
  }, [_c('div', {
    staticClass: "movie-detail__poster-img"
  }, [_c('img', {
    staticClass: "img-responsive-height",
    attrs: {
      "src": _vm.item.movie.poster,
      "alt": ""
    }
  })]), _vm._v(" "), (!_vm.$breakpoints.xs) ? _c('sk-icon', {
    staticClass: "movie-detail__poster-play",
    attrs: {
      "play": ""
    }
  }) : _vm._e()], 1) : ((!_vm.item.use_movie_poster || _vm.item.use_movie_poster == '0') && _vm.item.images && _vm.item.images.poster && _vm.item.images.poster.url) ? _c('div', {
    staticClass: "movie-detail__poster movie-detail__poster-img--no-trailer"
  }, [_c('div', {
    staticClass: "movie-detail__poster-img"
  }, [_c('img', {
    staticClass: "img-responsive-height",
    attrs: {
      "src": _vm.item.images.poster.url,
      "alt": ""
    }
  })])]) : _vm._e()]], 2), _vm._v(" "), (_vm.$breakpoints.smDown) ? _c('div', {
    staticClass: "exclusive__content"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md6": "",
      "lg6": ""
    }
  }, [(_vm.item.big_title) ? _c('h2', {
    staticClass: "h1"
  }, [_vm._v(_vm._s(_vm.item.big_title))]) : _vm._e(), _vm._v(" "), _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.title)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.strapline)
    }
  }), _vm._v(" "), (!_vm.festival) ? _c('div', {
    staticClass: "exclusive__content-btns"
  }, [(!_vm.item.vista_movie_id && (_vm.item.button_link || _vm.item.button_text)) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": _vm.item.button_link,
      "block": ""
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.item.button_text) + "\n                        ")]) : ((_vm.item.vista_movie_id && (!_vm.item.button_link || !_vm.item.button_text)) || _vm.item.vista_movie_id && (_vm.item.button_link || _vm.item.button_text)) ? _c('sk-button', {
    attrs: {
      "block": _vm.$breakpoints.xs,
      "primary": _vm.item.vista_movie_id ? true : false,
      "tag": "a",
      "href": ("/details/" + (_vm.item.vista_movie_id))
    }
  }, [_vm._v(_vm._s(_vm.item.button_text || 'Book to Win') + "\n                        ")]) : _vm._e(), _vm._v(" "), ((_vm.item.button_2_link || _vm.item.button_2_text)) ? _c('sk-button', {
    attrs: {
      "block": _vm.$breakpoints.xs,
      "tertiary": _vm.item.vista_movie_id != '',
      "primary": _vm.item.vista_movie_id == '',
      "tag": "a",
      "href": _vm.item.button_2_link
    }
  }, [_vm._v(_vm._s(_vm.item.button_2_text) + "\n                        ")]) : (_vm.promo) ? _c('sk-button', {
    attrs: {
      "tertiary": _vm.item.vista_movie_id != '',
      "block": _vm.$breakpoints.xs,
      "primary": _vm.item.vista_movie_id == '',
      "tag": "a",
      "href": ("/promotion/" + (_vm.item.nid))
    }
  }, [_vm._v("View Promotion Details\n                        ")]) : (_vm.event) ? _c('sk-button', {
    attrs: {
      "tertiary": _vm.item.vista_movie_id != '',
      "block": _vm.$breakpoints.xs,
      "primary": _vm.item.vista_movie_id == '',
      "tag": "a",
      "href": ("/event/" + (_vm.item.nid))
    }
  }, [_vm._v("View Event Details\n                        ")]) : _vm._e()], 1) : _c('div', {
    staticClass: "exclusive__content-btns"
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "block": _vm.$breakpoints.xs,
      "href": ("/film-festival-details/" + (_vm.item.nid))
    }
  }, [_vm._v("See Features\n                        ")])], 1)])], 1)], 1) : _vm._e()]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0510a804","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/exclusive-to-sk/exclusive-list.vue
// module id = 764
// module chunks = 0